<template>
  <div class="border-b border-balternative-color mb-4">
    <fieldset class="categories border-0 p-0 px-6">
      <div class="grid grid-cols-2 mb-2">
        <div class="text-xl text-pdsPrimaryColor">Categorieën</div>
        <div class="text-end">
          <ChevronDownIcon
            @click.prevent="toggleDetails()"
            v-if="!collapsed"
            class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor-pointer"
            aria-hidden="true"
          />
          <ChevronUpIcon
            @click.prevent="toggleDetails()"
            v-else
            class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor-pointer"
            aria-hidden="true"
          />
        </div>
      </div>
      <recursive-categories
        class="mb-4"
        v-if="!collapsed"
        :categories="transformedCategories"
        @expand-state-changed="onExpandStateChanged"
        @input="onRecursiveCategoriesInput"
      />
    </fieldset>
    <div
      class="flex justify-end place-content-end items-start md:items-end self-start flex-wrap flex-row mb-4 mr-6"
      v-if="value !== null"
    >
      <button
        @click.prevent="goToAllProducts()"
        class="flex justify-center py-2 px-2 md:px-4 shadow-sm text-sm font-medium text-white bg-primary-default rounded-full hover:bg-primary-default/50 items-center"
      >
        <ArrowLeftIcon class="h-5 w-5 inline-block text-white cursor-pointer" aria-hidden="true" />
        <span class="">Alle producten tonen</span>
      </button>
    </div>
  </div>
</template>

<script>
import { ArrowLeftIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/20/solid';
import { useResponsiveCollapse } from '@/composables/useResponsiveCollapse';
import RecursiveCategories from './RecursiveCategories.vue';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { currentUserIdentity$ } from '@/services';

export default {
  name: 'VCategories',
  components: {
    ArrowLeftIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    RecursiveCategories
  },
  props: {
    categories: Array,
    value: Object,
    isAssortmentFlow: Boolean
  },
  setup() {
    const { collapsed } = useResponsiveCollapse();
    const store = useStore();
    const currentUserIdentity = ref(null);
    const previousSelectedCategories = computed(() => store.getters['catalog/getPreviousSelectedCategories']);
    const setPreviousSelectedCategories = (value) => store.commit('catalog/setPreviousSelectedCategories', value);

    currentUserIdentity$.subscribe((value) => {
      currentUserIdentity.value = value;
    });

    const toggleDetails = () => {
      collapsed.value = !collapsed.value;
    };

    return {
      collapsed,
      toggleDetails,
      currentUserIdentity,
      previousSelectedCategories,
      setPreviousSelectedCategories
    };
  },
  data() {
    return {
      activeCategory: null,
      transformedCategories: []
    };
  },
  watch: {
    value(val) {
      if (!val) {
        this.loadTransformedCategories();
      }
    },
    categories: {
      handler(newCategories, oldCategories) {
        this.loadTransformedCategories();
      }
    }
  },
  mounted() {
    this.loadTransformedCategories();
  },
  methods: {
    loadTransformedCategories() {
      const cb = (cats) => {
        const r = [];
        if (cats) {
          cats.forEach((c) => {
            let expandStatus = false;
            this.previousSelectedCategories.forEach((psc) => {
              if (psc.category.categoryId === c.categoryId) {
                expandStatus = true;
              }
            });
            if (this.value && this.value.categoryId === c.categoryId) {
              expandStatus = true;
            }
            r.push({
              expanded: expandStatus,
              active: expandStatus,
              category: c,
              children: cb(c.childItems)
            });
          });
        }

        return r;
      };
      if (this.isAssortmentFlow) {
        const result = cb(this.categories);
        this.transformedCategories = result;
      } else {
        const result = cb(
          this.categories.filter((obj) =>
            this.currentUserIdentity.userTreatmentArea.map((area) => area.treatmentAreaId).includes(obj.treatmentAreaId)
          )
        );
        this.transformedCategories = result;
      }
    },
    onExpandStateChanged(value) {
      if (this.previousSelectedCategories.length > 0) {
        // reset when they are not present in the `value`
        this.previousSelectedCategories.forEach((previousSelectedCategory) => {
          const i = value.indexOf(previousSelectedCategory);
          if (i < 0) {
            previousSelectedCategory.expanded = false;
          }
        });
      }

      this.setPreviousSelectedCategories(value);
    },
    onRecursiveCategoriesInput(value) {
      if (this.activeCategory) {
        this.activeCategory.active = false;
      }
      this.activeCategory = value;

      if (value) {
        value.active = true;
        this.$emit('update:modelValue', value.category);
      } else {
        this.$emit('update:modelValue', null);
      }
    },
    goToAllProducts() {
      this.onRecursiveCategoriesInput(null);

      if (this.previousSelectedCategories.length > 0) {
        // reset when they are not present in the `value`
        this.previousSelectedCategories.forEach((previousSelectedCategory) => {
          previousSelectedCategory.expanded = false;
        });
      }
    }
  }
};
</script>
